import Resource from '@/api/resource';
import request from '@/utils/request';

const DashboardResource = new Resource('dashboard');

export default {
  /**
   * Récupère les options de filtres pour les périodes
   */
  getPeriodFilters() {
    return DashboardResource.sublist('/filters/periodes', {});
  },

  /**
   * Récupère les options de filtres pour les niveaux d'analyse
   */
  getNiveauFilters(params = {}) {
    return DashboardResource.sublist('/filters/niveaux', params);
  },

  /**
   * Récupère les options de filtres pour les cultures
   */
  getCultureFilters() {
    return DashboardResource.sublist('/filters/cultures', {});
  },

  /**
   * Récupère les options de filtres pour les certifications
   */
  getCertificationFilters() {
    return DashboardResource.sublist('/filters/certifications', {});
  },

  /**
   * Récupère les producteurs selon les filtres
   */
  getProducteursFilters(params = {}) {
    return DashboardResource.sublist('/filters/producteurs', params);
  },

  /**
   * Récupère les KPIs selon les filtres
   */
  getKPIs(data) {
    return request({
      url: '/dashboard/kpis',
      method: 'post',
      data: data,
    });
  },

  /**
   * Récupère les statistiques par antenne
   */
  fetchAntennesStats(params = {}) {
    return DashboardResource.sublist('/antennes', params);
  },

  /**
   * Récupère les statistiques de certification
   */
  fetchCertificationStats(params = {}) {
    return DashboardResource.sublist('/certifications', params);
  },

  /**
   * Récupère les données pour le graphique d'évolution des récoltes
   */
  getRecoltesChart(data) {
    return request({
      url: '/dashboard/charts/recoltes',
      method: 'post',
      data: data,
    });
  },

  /**
   * Récupère les données pour le graphique d'évolution des contrôles internes
   */
  getControlesChart(data) {
    return request({
      url: '/dashboard/charts/controles',
      method: 'post',
      data: data,
    });
  },

  /**
   * Récupère les données pour le graphique de répartition géographique
   */
  getRepartitionGeoChart(data) {
    return request({
      url: '/dashboard/charts/repartition-geo',
      method: 'post',
      data: data,
    });
  },

  /**
   * Récupère les données pour le graphique de répartition des cultures
   */
  getRepartitionCulturesChart(data) {
    return request({
      url: '/dashboard/charts/repartition-cultures',
      method: 'post',
      data: data,
    });
  },

  /**
   * Récupère les données pour le graphique radar de performance par antenne
   */
  getPerformanceAntennesChart(data) {
    return request({
      url: '/dashboard/charts/performance-antennes',
      method: 'post',
      data: data,
    });
  },

  /**
   * Récupère les données pour le graphique d'évolution des surfaces par certification
   */
  getEvolutionCertificationChart(data) {
    return request({
      url: '/dashboard/charts/evolution-certification',
      method: 'post',
      data: data,
    });
  },

  /**
   * Traite une requête IA pour extraire des filtres en langage naturel
   */
  processAIQuery(data) {
    return request({
      url: '/ai/process-query',
      method: 'post',
      data: data,
    });
  },
};

